import React from 'react';
import style from './loading.css';
const Loading = () => (React.createElement("div", { className: style.loadingWrapper },
    React.createElement("div", { className: style.loading }),
    React.createElement("div", { className: style.message }, "Just a second, we're adding some detail to your Scene")));
export default Loading;
